<div class="family-access">
    <div class="family-access__loader" *ngIf="isLoadData">
        <div class="family-access__loader-animation">
            <loader type="page" message="Загружаем ..."> </loader>
        </div>
    </div>

    <div class="family-access__container" *ngIf="!isLoadData">
        <div class="family-access__header">
            <p>Кабинет родственника</p>
            <button
                class="family-access__header-close"
                type="button"
                (click)="closeModal()"
            ></button>
        </div>
        <ng-container
            *ngIf="familyList && familyList.length > 0; else elseBlock"
        >
            <div class="family-access__body">
                <div class="family-access__family-list">
                    @for (member of familyList; track member.keyId) {
                        <button
                            class="family-access__button"
                            [ngClass]="{
                                'family-access__button--selected':
                                    selectedFamilyMemberId === member.keyId,
                            }"
                            (click)="selectedFamilyMemberId = member.keyId"
                        >
                            <div class="family-access__button-content">
                                <div class="family-access__button-fio">
                                    {{ member.fio }}
                                </div>
                                <div class="family-access__button-age">
                                    {{ member.age }}
                                </div>
                            </div>
                        </button>
                    }
                </div>

                <button
                    class="family-access__submit-button"
                    [disabled]="!selectedFamilyMemberId"
                    (click)="submitMember()"
                >
                    Перейти
                </button>
            </div>
        </ng-container>
        <ng-template #elseBlock>
            <div class="family-access__body">
                <div class="family-access__not-found">
                    <img
                        class="family-access__not-found-image"
                        src="./assets/icons/account/family-not-found.svg"
                        alt="Не найдено родственников"
                    />
                    <div class="family-access__not-found-text">
                        Для получения доступа в Кабинет родственника <br />
                        обратитесь в регистратуру медицинской организации
                    </div>
                </div>
                <button
                    class="family-access__submit-button"
                    routerLink="/home"
                    (click)="closeModal()"
                >
                    Вернуться на главную
                </button>
            </div>
        </ng-template>
    </div>
</div>
